import { createSlice } from "@reduxjs/toolkit";



const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    notifications: [], 
    latest: null,
    notificationCount:0,      
  },
  reducers: {
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload); // add to beginning
      state.latest = action.payload;
    },
    clearNotifications: (state) => {
      state.notifications = [];
      state.latest = null;
    },
    setNotificationCount:(state,action)=>{
      state.notificationCount=action?.payload
    }
  },
});

export const { addNotification, clearNotifications,setNotificationCount } = notificationSlice.actions;
export const notificationReducer = notificationSlice.reducer;